// removed by extract-text-webpack-plugin
module.exports = {"promo-code-list-item":"N-eq4gclV _38fsqHPnh _2E9qGyV4u Ve18E2zgo _3cWZ9MSKx _3v9QXXXDN OSBVy-e59 _3BiTzCAU-","field":"_2b_KBw8G- _2sGa7qNeF","description":"_22RY6ERLD _2l0xl0HVf _2FytPShLI _3QfjnbU8u _2SpyW05bO _2LQmf5WSW _2SKVr1fPM","validity":"_1brkhhf0G _1jY4uEptA","actions":"_3HC-wkvdI _17qxy1jyE _34YKmqAjT _2l0xl0HVf _5RUN9357o _18QA6WPGs _25kSC1d_D _2SpyW05bO _2RfG69JFv","button":"ApbRD4HDE _1jY4uEptA _3s79lgi83"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/promo-code-list/promo-code-list-item/promo-code-list-item.css
 ** module id = 2152
 ** module chunks = 0
 **/